'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _session = require('redux/modules/session');

var _calendar = require('redux/modules/calendar');

var _customize = require('redux/modules/customize');

var _availability = require('redux/modules/availability');

var _profile = require('redux/modules/profile');

var _analytics = require('redux/modules/booking/analytics');

var _trip = require('redux/modules/trip');

var _payment = require('redux/modules/payment');

var _popup = require('redux/modules/popup');

var _buffet = require('redux/modules/buffet');

var _search = require('redux/modules/search');

var _wishlist = require('redux/modules/wishlist');

var _toast = require('redux/modules/toast');

var _home = require('redux/modules/home');

var _digi = require('redux/modules/digi');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import config from 'config';

// import analytics from 'redux-analytics';
var events = [_session.analytics, _calendar.analytics, _customize.analytics, _availability.analytics, _profile.analytics, _analytics.analytics, _trip.analytics, _payment.analytics, _popup.analytics, _buffet.analytics, _search.analytics, _wishlist.analytics, _toast.analytics, _home.analytics, _digi.analytics].reduce(function (a, b) {
  return _lodash2.default.merge(a, b);
}, {});

exports.default = function (_ref) {
  var getState = _ref.getState;
  return function (next) {
    return function (action) {
      // console.log('A Before', action);
      var defaultProviders = ['database', 'googleAnalytics', 'mixpanel'];
      var providers = defaultProviders;
      var eventCreator = events[action.type];
      if (!eventCreator || __SERVER__) {
        return next(action);
      }
      var event = eventCreator(action, getState);
      if (!event) {
        return next(action);
      }
      if (event.providers) {
        providers = event.providers.split(' ');
        var markRemoved = providers.map(function (provider) {
          return provider.replace(/[\+\-]/, '');
        });
        if (providers.every(function (provider) {
          return (/^\-/.test(provider)
          );
        })) {
          providers = _lodash2.default.difference(defaultProviders, markRemoved);
        } else {
          providers = markRemoved;
        }
      }
      if (providers.indexOf('googleAnalytics') >= 0) {
        if (event.loggedIn) {
          _reactGa2.default.set({ userId: action.userId }, ['auTracker']);
        }
        if (event.loggedOut) {
          _reactGa2.default.set({ userId: null }, ['auTracker']);
        }
        if (event.path) {
          _reactGa2.default.pageview(event.path, ['auTracker']);
        } else {
          _reactGa2.default.event({
            category: event.category,
            action: event.name,
            value: event.value
          }, ['auTracker']);
          if (event.virtualPath) {
            _reactGa2.default.pageview(event.virtualPath, ['auTracker']);
          }
        }
      }
      // if (providers.indexOf('mixpanel') >= 0 && __CLIENT__) {
      //   const mixpanel = require('mixpanel-browser');
      //   mixpanel.init(config.mixpanel.token);
      //   if (event.loggedIn && mixpanel && mixpanel.identify) {
      //     mixpanel.identify(action.userId);
      //   }
      //   if (event.path) {
      //     mixpanel.track('Page View', event);
      //   } else {
      //     mixpanel.track(event.name, event);
      //   }
      // }
      if (providers.indexOf('database') >= 0) {
        event.path = window && window.location && window.location.pathname; // handle server-side
        _superagent2.default.post('/api/logs').send({
          namespace: event.category,
          title: event.name,
          data: event
        }).end();
      }
      // console.log('A After ', action);
      return next(action);
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/analyticsMiddleware.js
// module id = 1698
// module chunks = 47